import { Divider as DividerComponent, type DividerProps } from '@heroui/react';
import { cn } from '../../cn';

export const Divider = ({ className, ...props }: DividerProps) => {
  return <DividerComponent className={cn(className)} {...props} />;
};
